import { noop } from 'lodash';

/**
 * @function inputProperties
 * @param {object} props
 * @return {object} the input to be build with its properties
 */
export const inputProperties = function inputProperties(
  {
    context,
    children,
    date = null,
    selected = null,
    checked = false,
    disabled = false,
    loading = false,
    fn = null,
    fnMin = null,
    fnMax = null,
    fnAutocomplete = null,
    fnFormat = undefined,
    fnFormatQuickTag = undefined,
    shouldValidate = false,
    isValid = true,
    customValidation,
    inputIndicator = null,
    inputIconIndicator = null,
    icon = null,
    disabledIcon = null,
    inputSuggestion,
    onKeyUp = null,
    onKeyPress = null,
    checkboxOnLeft = false,
    disabledOptions = [],
    optionsHeight = undefined,
    optionsPosition = undefined,
    optionsTypeahead = undefined,
    optionsCount = undefined,
    optionsFn = null,
    onFocus = noop,
    onBlur = noop,
    size = 'default',
    color = null,
    dropdownFooter,
    dropdownFooterHeight,
    clearOnChange = undefined,
    autoFocus: propAutoFocus,
    validationErrorIndicator = true,
    clearable,
    showRightSideLabel = false,
    rightLabelText = '',
    onClear,
    onInnerRef,
    ariaDescribedby,
    withSelector,
    withClear,
    quickListSimple,
    customDescription,
    tagsEmptyState,
    getTextRef,
    dataManual,
    limit,
    editable,
    extraFloatingContentHeight,
    dropdownSize = 24,
    tooltip,
    selectionTooltip,
    sessionToken,
    keepOpenOnSelect = false,
    ...props
  },
  position = ''
) {
  const {
    id,
    label,
    inputType,
    autoComplete,
    ariaLabel,
    options = null,
    bullhornOptions = [],
    selectionSource = null,
    inputDescription = null,
    required = false,
    min = 0,
    max = 0,
    format = undefined,
    name = null,
    minlength = undefined,
    maxlength = undefined,
    minDate = undefined,
    maxDate = undefined,
    readonly = false,
    yearDropdown = true,
    presentSelect = undefined,
    idSelector = null,
    nameSelector = null,
    iconContextSelector = null,
    fullWidth = undefined,
    showCharactersCounter = false,
    charactersCounterIntl = undefined,
    rows = null,
    quick = [],
    freetext = false,
    shouldAddOnComma = true,
    shouldAddOnBlur = false,
    button = null,
    acceptedFormats = undefined,
    acceptedDimensions = undefined,
    maxFileSize = undefined,
    bullhornFilesProps = undefined,
    autoFocus: contextAutoFocus,
    height,
    minHeight,
    maxHeight,
    listWithoutPlaceholder,
    withFloatingTextTools,
    promptSuggestions,
    withButtonAskAI,
    withBarTextTools,
    textToolsOptions,
    floatingTextToolsOptions,
    stickyToolbar,
    richContent,
    withAnchoredAskAI,
    variablesList,
    variablesI18n,
    resizable,
    noNewLineOnEnter,
    readOnlySuffix = null,
    showPlaceholderWhenDisabled,
    maxAriaLabel,
  } = context;

  let inputChangeFunction = null;

  if (fn) {
    inputChangeFunction = fn;
  }
  if (fnMin) {
    inputChangeFunction = fnMin;
  }
  if (fnMax && position === 'Second') {
    inputChangeFunction = fnMax;
  }
  const inputValue = props[`inputValue${position}`];

  return {
    id,
    name,
    key: `${id}-${position}`,
    children,
    readonly,
    minlength,
    maxlength,
    label,
    inputDescription,
    inputIndicator,
    inputIconIndicator,
    icon,
    disabledIcon,
    button,
    placeholder: context[`placeholder${position}`] || {},
    minPlaceholder: context.minPlaceholder || {},
    maxPlaceholder: context.maxPlaceholder || {},
    inputValue: inputValue === 0 ? 0 : inputValue || '',
    inputSuggestion,
    date,
    inputType,
    autoComplete,
    ariaLabel,
    maxAriaLabel,
    ariaDescribedby,
    options,
    bullhornOptions,
    optionsFn,
    selected,
    selectionSource,
    checked,
    disabled,
    loading,
    min,
    max,
    format,
    rows,
    required,
    shouldValidate,
    customValidation,
    isValid,
    minDate,
    maxDate,
    yearDropdown,
    presentSelect,
    onKeyUp,
    onFocus,
    onBlur,
    onKeyPress,
    idSelector,
    nameSelector,
    iconContextSelector,
    fullWidth,
    checkboxOnLeft,
    disabledOptions,
    optionsHeight,
    optionsPosition,
    optionsTypeahead,
    optionsCount,
    size,
    color,
    quick,
    freetext,
    shouldAddOnComma,
    shouldAddOnBlur,
    fnAutocomplete,
    fnFormat,
    fnFormatQuickTag,
    bullhornFilesProps,
    clearOnChange,
    dropdownFooter,
    dropdownFooterHeight,
    showCharactersCounter,
    charactersCounterIntl,
    showRightSideLabel,
    rightLabelText,
    fn: inputChangeFunction,
    autoFocus: propAutoFocus || contextAutoFocus,
    validationErrorIndicator,
    clearable,
    onClear,
    onInnerRef,
    withSelector,
    withClear,
    acceptedFormats,
    acceptedDimensions,
    maxFileSize,
    quickListSimple,
    customDescription,
    tagsEmptyState,
    withFloatingTextTools,
    promptSuggestions,
    withButtonAskAI,
    withBarTextTools,
    textToolsOptions,
    floatingTextToolsOptions,
    stickyToolbar,
    richContent,
    withAnchoredAskAI,
    height,
    minHeight,
    maxHeight,
    listWithoutPlaceholder,
    getTextRef,
    variablesList,
    variablesI18n,
    resizable,
    dataManual,
    limit,
    noNewLineOnEnter,
    editable,
    extraFloatingContentHeight,
    dropdownSize,
    tooltip,
    selectionTooltip,
    readOnlySuffix,
    sessionToken,
    showPlaceholderWhenDisabled,
    keepOpenOnSelect,
  };
};
